/**
 * @fileoverview Input/output schemas for world-organization-snapshotter-v3.
 *
 * This agent updates a world organization's state after a chapter has been written.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldOrganizationAttributesV3Schema, WorldOrganizationSnapshotV3Schema } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  worldOrganization: z.object({
    id: z.string(),
    name: z.string(),
    type: z.literal('organization'),
    element: z.enum(['faction', 'nation', 'institution']),
    initialDescription: z.string().optional(),
  }).describe('The world organization being snapshotted.'),
  previousSnapshot: WorldOrganizationSnapshotV3Schema.optional().describe('The organization state before this chapter.'),
  chapterContent: z.string().describe('The full content of the chapter to analyze.'),
  chapterNumber: z.number().describe('The chapter number for snapshot metadata.'),
});

export type Input = z.infer<typeof InputSchema>;

export const OutputSchema = WorldOrganizationAttributesV3Schema.extend({
  notPresentInChapter: z.boolean().optional().describe('True if the organization was not mentioned or relevant in this chapter.'),
});

export type Output = z.infer<typeof OutputSchema>;
